import { useLayoutEffect, useRef, useState } from 'react';

/** Max width (px) for a single-column item before switching to multiple lanes. */
export const SINGLE_ITEM_MAX_WIDTH = 435;

export const useResponsiveLanes = (
  enabled: boolean,
  { singleItemMaxWidth, maxLanes }: { singleItemMaxWidth: number; maxLanes: number }
) => {
  const ref = useRef<HTMLDivElement>(null);
  const [lanes, setLanes] = useState(1);

  useLayoutEffect(() => {
    if (!enabled) return;

    const el = ref.current;
    if (!el) return;

    const update = () => {
      const next = el.clientWidth > singleItemMaxWidth ? maxLanes : 1;
      setLanes((prev) => (prev === next ? prev : next));
    };

    const observer = new ResizeObserver(update);
    observer.observe(el);
    update();

    return () => observer.disconnect();
  }, [enabled, singleItemMaxWidth, maxLanes]);

  return { ref, lanes };
};
